module.exports = __webpack_public_path__ + "static/media/logo.d5163e19.png";